import {Component, ElementRef, ViewChild} from '@angular/core';
import {NavController, ToastController, AlertController, ModalController} from 'ionic-angular';
import { Headers , RequestOptions } from '@angular/http';

import {SearchCustomersPage} from "../search-customers/search-customers";

import {CartPage} from '../cart/cart';
import {CartManager} from "../../providers/cart-manager";

import {ItemsPage} from '../items/items';


import {Api} from '../../providers/api';

import {IMAGES_BASE_URL,Constants,ApplicationVariables } from '../../providers/config';

import 'rxjs/add/operator/map';
import { Storage } from '@ionic/storage';
import {NavParams } from 'ionic-angular';
import {Printer, PrintOptions} from 'ionic-native';
import { MsgManager } from '../../providers/msg-manager';
import {CART, loginUserInfo, RoutingInfo} from '../../providers/data';
import {GVLogger} from "../../services/gv-logger";
import {ItemPage} from "../item-details/item-details";
import {LoginPage} from "../login/login";
import {FileUploader} from "ng2-file-upload";
import {MyOrderPage} from "../my-order/my-order";
import {Base64} from "js-base64";
import {OrderConfirmPage} from "../order-confirm/order-confirm";
import {WorkOrdersPage} from "../work-orders/work-orders";
import QRCode from 'qrcode';
import {LocationsListPage} from "../locations-list/locations-list";
import {LableTypesPage} from "../lables-types/lable-types";
import {ConsumeStockCart} from "../consume-stock-cart/consume-stock-cart";


@Component({
  selector: 'page-order-view',
  templateUrl: 'work-order-view.html'
})
export class WorkOrderViewPage {

  baseImageUrl = IMAGES_BASE_URL.imageBaseUrl;

  @ViewChild('divID') divID: ElementRef;
  @ViewChild('divID2') divID2: ElementRef;

  isOfflineMode:any;

  salesPerson;

  currentDate;
  placeOrderButton = true;

  attributesPropertiesMap:any = new Map();
  shipto = '';
  constants = Constants;

  space: string = ", ";
  spaceAddress1 : string;
  spaceAddress2 : string;

  adpCustomerInfo :any ={};
  TAX = 0;
  tr = [];
  tr2 = [];
  tr3 = [];
  pages = []
  pages2 = []
  pages3 = []

  public cart: any;
  public TotalPrice: number =0;
  public TotalPriceBeforeTax: number = 0;
  public taxPercent = 0; // Changed from 0.13
  public taxAmount = 0;
  public locationSelected: any;
  public locationSelectedObject: any;
  public expectedShipmentDate: any = "";
  public orderMessage = "";
  spaceCity: string;
  spaceState: string;
  workOrder: any;
  selectFirstBillTo: any;
  spaceZipCode: any;
  priceBeforeShippingCost;
  shippingCost;
  totalTax = 0.0;
  totalConsumerTax = 0.0;
  totalConsumerShippingCost = 0.0;
  isB2CSaleChannel = true;
  isB2BDropshipper = true;

  public uploader: FileUploader = new FileUploader({});
  public hasBaseDropZoneOver: boolean = false;
  fileIsOver:boolean;
  documents = [];
  generate = "";

  restrictedToViewOrder = loginUserInfo.restrictedToViewOrder;
  newOrderMessage = ""
  skusJson;
  skusJsonExpended = [];
  warehouseType = "Warehouse";
  loggedInUserWarehouseId = loginUserInfo.assignedWarehouseId
  from = "View"
  offset = 0

  consumedItemsList = []

  constructor(public nav: NavController,
   private cartManager:CartManager,
   private api:Api,public storage: Storage,
    public toastCtrl: ToastController,
    public params:NavParams,
     public alertCtrl: AlertController,
     private modalController:ModalController,
     private msgManager:MsgManager, private gVLogger: GVLogger) {

    // this.process()

      this.getWarehouse();

      // this.attributesPropertiesMap = this.cartManager.getAllAttributesPropertiesMap();
      this.adpCustomerInfo = this.cartManager.getAdpCustomerInfo();

    this.salesPerson = this.cartManager.getSalesPerson();
    // this.isOfflineMode  = ApplicationVariables.isOffline;

      // this.workOrder = this.params.get("workOrder");
      this.workOrder = this.params.get("workOrder");

      if(this.workOrder.type === "Make to Stock")
        this.getConsumedItems();
      this.from = this.params.get("from");
      this.gVLogger.log("order" + JSON.stringify(this.workOrder) );

      this.skusJson = JSON.parse(this.workOrder.skusJson);


      // for(let i = 0; i < this.offset; i++){
      //   let obj = {productName:"",upcCode:"",quantityPicked:0, scanCode:""}
      //   this.skusJsonExpended.push(obj);
      // }
      //
      // for(let sku of this.skusJson){
      //   for(let i =0; i < sku.quantityPicked; i++){
      //     let obj = {productName:sku.productName,upcCode:sku.upcCode,quantityPicked:sku.quantityPicked}
      //     this.skusJsonExpended.push(obj);
      //   }
      // }
      // this.process()
    this.addBarCodeForPrint();

      this.currentDate = new Date();

    this.getDocuments();

  }


  clearCart(){
    let confirm = this.alertCtrl.create({
      title: 'Are you sure?',
      message: 'Do you agree to Clear all the Products from cart',
      buttons: [
        {
          text: 'Cancel',
          handler: () => {
            this.gVLogger.log('Disagree clicked');
          }
        },
        {
          text: 'Agree',
          handler: () => {
            this.gVLogger.log('Agree clicked');
            this.cartManager.clearCartProducts();
            this.nav.pop().then(()=>{this.nav.pop()});
          }
        }
      ]
    });
    confirm.present();

  }

  shipDateChanged(event){
    this.gVLogger.log(this.expectedShipmentDate);
    this.cartManager.setShipDate(this.expectedShipmentDate);
  }

  updateOrderMessageInCART(){
    this.cartManager.setOrderMessage(this.orderMessage);
  }

  updateOrderMessage($event){
    this.gVLogger.log("Blured called");
    this.updateOrderMessageInCART();
  }

  doPrint(){
    let options: PrintOptions = {
     name: 'Purchase Order'
    };

    Printer.isAvailable().then(
      function(){
        //alert("Printer is availabel");
        Printer.print(document.getElementById("print-from"), options).then(function(){},function(){});
      }
      ,
      function(){
        alert("Printer is not available");
      }
      );
  }

  imageNotFound(e,item){
   item.productImagesDTO[0].extension = "png";
   item.productImagesDTO[0].name = "dummy";
  }


  reOrder(){

  		this.gVLogger.log(this.cart.customerDTO);

  		if(this.cartManager.getProductsCount()){

			let confirm = this.alertCtrl.create({
            title: 'Are you sure?',
            message: "Do you agree to delete all the Products for '"+ this.cartManager.getCustomerName() +"' from cart",
            buttons: [
              {
                text: 'Goto Cart', // cancel
                handler: () => {
                  this.nav.setRoot(ItemsPage).then(()=>{this.nav.push(CartPage)});
                }
              },
              {
                text: 'Discard Cart', // agree
                handler: () => {

                  this.addtoCart();
                }
              }
            ]
          });
          confirm.present();

  		}else{
        this.addtoCart()
  		}


  }

addtoCart(){
	this.cartManager.setCustomer(this.cart.customer);
  this.cartManager.setOrderMessage(this.cart.orderMessage);
  this.cartManager.setOrderId(0);
  this.cartManager.setItems(this.cart.items);
  //this.nav.push(CartPage);
  this.nav.setRoot(ItemsPage).then(()=>{this.nav.push(CartPage)});
}

discountCheck(discountPrice){ // if discount price is > 0, return true
    if(Number(discountPrice) > 0){
      return true;
    }else{
      return false;
    }
  }




  decimalLengthFixed(num,max){
    return Number(num).toFixed(Math.max(2, (num.toString().split('.')[1] || []).length))
  }



  doPrintWeb(){

  this.printToCart("print-from");

    }

  doScanCodesPrintWeb(){

    this.printToCart("print-scancode");

  }

  doScanCodesPrintWeb2(){

    this.printToCart("print-scancode2");

  }

  doScanCodesPrintWeb3(){

    this.printToCart("print-scancode3");

  }


  stringify(string){
    return JSON.stringify(string)
  }


  printToCart(printSectionId: string){
          let popupWinindow;
          let innerContents = document.getElementById(printSectionId).innerHTML;
          popupWinindow = window.open('', '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
          popupWinindow.document.open();
          popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="style.css" /></head><body onload="window.print()">' + innerContents + '</html>');
          popupWinindow.document.close();
    }

    makeImageURL(dimensions,item){
    // item.productImagesDTO = [{name : "dummy", extension:"png"}]

      // let image
      // item.productImagesDTO[0].extension = "png";
      // item.productImagesDTO[0].name = "dummy";
  return this.cartManager.makeImageURL(dimensions,item);
}


getSquareLogo(){
    return IMAGES_BASE_URL.imageBaseUrl + "/" + this.cartManager.getADPCustomerUUID() + "/branding/logoSquare.png?v="+Math.round((new Date()).getTime() / 1000);
  }

  locationAddress1(addressLine1){
    // this.gVLogger.log("locationAddress1 called" + addressLine1);
    if(addressLine1 === "" || addressLine1 === null || addressLine1 === undefined){
      return false;
    }
    else
    {
      return true;
    }
  }


    refreshTotalPrice(){
      this.cart = CART;
      let temp:number = 0;
      for(let item of this.cart.items){
          if(this.discountCheck(item.discountPrice)){
            temp =  temp + (Number(item.discountPrice) * Number(item.quantityOrdered));
          }else{

          temp =  temp + (Number(item.price) * Number(item.quantityOrdered));
          }
      }
      this.TotalPriceBeforeTax =  Number(temp.toFixed(2));
      this.TAX = (this.TotalPriceBeforeTax * this.taxPercent);
     this.TotalPrice = this.TotalPriceBeforeTax + this.TAX;
      //alert(JSON.stringify(this.cart));
   }

   locationTypeCheck(locationsDTOs){

    for(let loc of locationsDTOs){
      if(loc.locationType === "BILLTO" || loc.locationType === "BILLTOSHIPTO"){
        return this.selectFirstBillTo = loc;
      }
    }
  }

  imageNotFoundServer(event){
    event.target.src = "http://anydatapoint.net/f9c5c5ba-3900-4cdc-946d-93979d29f33c/branding/default-logo.png";
   }

  viewItem(item) {

    this.api.get("product/" + item.id + "/?isWebStore=" + 1).map(res => res.json()).subscribe(data => {
      if(data.status === "200"){
        item.description = data.data.description;
      }
    })
    this.nav.push(ItemPage, {item: item})
  }


  commentHtml(description){
    // this.gVLogger.log( "decjsdkld ghjd gnkxdhn   : " + atob(description));
    if(description !== undefined){
      try {
        // this.gVLogger.log("In try decoded description : " + Base64.decode(description));
        // this.gVLogger.log("In try encoded description : " + description);
        this.divID.nativeElement.innerHTML = description;
      }
      catch (e) {
        this.gVLogger.log("In catch decoded description : ")
        this.divID.nativeElement.innerHTML = description;
      }
    }else {
      return "";
    }


  }

  getWarehouse() {


    this.api.get("locations/getParentInventoryLocationById?id=" + this.loggedInUserWarehouseId)
      .map(res => res.json())
      .subscribe(data => {
        if (data.status === "200") {
          this.warehouseType = data.data.type
        } else {
          this.warehouseType = "Warehouse"
        }
      });
    // }
  }


  end(order){
    order.doneBy = 1;
    order.createdAt = "";
    order.assignedAt = "";
    order.startedAt = "";
    if(order.startedBy > 0){
      order.started = 0;
      order.finished = 1
      this.api.post("workOrder/updateWorkOrder",order)
        .map(res=> res.json())
        .subscribe(data=>{
          // alert("Json "  + JSON.stringify(data))
          if(data.status == 200){

            order.doneBy = loginUserInfo.id
            this.msgManager.toastMsg("Work order successfully ended.");
            // return true;
          }else {
            this.msgManager.toastMsg("Some thing went wrong.");
            order.done = 0
          }

          this.nav.setRoot(WorkOrdersPage).then(() => {
          });
        },err=>{
          order.done = 0
          // this.presentToast("Server error.");
        });
    }else {
      order.doneBy = 0;
      this.api.toastMSG("You have to start task first!")
    }

  }

  addBarCodeForPrint(){
    for(let sku of this.skusJson){
      const qrcode = QRCode;
      const self = this;
      qrcode.toDataURL(sku.upcCode, { errorCorrectionLevel: 'H' }, function (err, url) {

        self.generate = url;
        console.log("uurr " + self.generate)
        sku.qrCode = self.generate;
        // return url;
      })
    }
  }

  process() {
    // alert("dd")
    console.log("this.skusJsonExpendedthis.skusJsonExpended "+ JSON.stringify(this.skusJsonExpended))
    for(let sku of this.skusJsonExpended){
      const qrcode = QRCode;
      const self = this;
      if(sku.productName !== ""){
        qrcode.toDataURL(sku.upcCode, { errorCorrectionLevel: 'H' }, function (err, url) {

          self.generate = url;
          console.log("uurr " + self.generate)
          sku.qrCode = self.generate;
          // return url;
        })
      }else {
        sku.qrCode = "assets/img/images.png";
      }

    }



    this.printSkusScanCodes()
    this.printSkusScanCodes2()
    this.printSkusScanCodes3()


    // return "data:image/png;base64,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"
  }
  printBarCode(){
    return "data:image/png;base64,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"
  }

  printSkusScanCodes(){

    let td = [];
    let count = 0
    let skusLength = this.skusJsonExpended.length;

    console.log("JJJJJJJJJJJJ "+ JSON.stringify(this.skusJsonExpended))
    for(let sku of this.skusJsonExpended){

      console.log("COOUUNNTTT "+ count + " " + skusLength);
      if(count % 3 === 0 && count !== 0){
        // This is full page rows push logic
        // Next 4 lines need to be changed
        // if(count % 30 === 0 && this.tr.length === 10){
        //   this.pages.push(this.tr);
        //   this.tr = []
        // }
        this.tr.push(td);
        td = [];

        td.push({code : sku.upcCode, scanCode : sku.qrCode, name : sku.productName, erpCode:sku.erpCode,workOrderRef:sku.workOrderRef})
        if(count === skusLength-1){
          // alert("INside %3")
          if(td.length === 1){
            // sku.qrCode = "assets/img/images.png";

            let obj = {code:"",scanCode:"assets/img/images.png",name:"", erpCode:"",workOrderRef:""}
            let obj2 = {code:"",scanCode:"assets/img/images.png",name:"", erpCode:"",workOrderRef:""}

            td.push(obj)
            td.push(obj2)
          }else if(td.length === 2){
            let obj = {code:"",scanCode:"assets/img/images.png",name:"", erpCode:"",workOrderRef:""}
            td.push(obj)
          }

          console.log("TDDDDDDDDDDDDDDDDDDDDDDD "  + JSON.stringify(td))
          this.tr.push(td);
          this.pages.push(this.tr);
          this.tr = []

        }
      }
      else if(count === skusLength-1) {
        console.log("inside : count === skusLength-1")
        // alert("count === skusLength-1")
        td.push({code : sku.upcCode, scanCode : sku.qrCode, name : sku.productName, erpCode:sku.erpCode,workOrderRef:sku.workOrderRef})

        if(td.length === 1){
          // sku.qrCode = "assets/img/images.png";
          let obj = {code:"",scanCode:"assets/img/images.png",name:"", erpCode:"",workOrderRef:""}
          let obj2 = {code:"",scanCode:"assets/img/images.png",name:"", erpCode:"",workOrderRef:""}

          td.push(obj)
          td.push(obj2)
        }else if(td.length === 2){
          let obj = {code:"",scanCode:"assets/img/images.png",name:"", erpCode:"",workOrderRef:""}
          td.push(obj)
        }

        // partial page rows push logic
        this.tr.push(td);
        this.pages.push(this.tr);
        this.tr = []
      }
      else {
        td.push({code : sku.upcCode, scanCode : sku.qrCode, name : sku.productName, erpCode:sku.erpCode,workOrderRef:sku.workOrderRef})
      }

      // This is full page rows push logic
      if(count % 30 === 0 && count !== 0){
        console.log("ggggggggggggggggggggggggggggggggggggggggggggggggg "+ count)
        this.pages.push(this.tr);
        this.tr = []
      }
      count++;
    }

    // console.log("xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx " + JSON.stringify(this.pages));
  }

  printSkusScanCodes2(){

    let td = [];
    let count = 0
    let skusLength = this.skusJsonExpended.length;
    for(let sku of this.skusJsonExpended){

      console.log("COOUUNNTTT "+ count + " " + skusLength);
      if(count % 2 === 0 && count !== 0){
        this.tr2.push(td);
        td = [];
        td.push({code : sku.upcCode, scanCode : sku.qrCode, name : sku.productName, erpCode:sku.erpCode,workOrderRef:sku.workOrderRef})
        if(count === skusLength-1){
          if(td.length === 1){
            let obj = {code:"",scanCode:"assets/img/images.png",name:"", erpCode:"",workOrderRef:""}

            td.push(obj)
          }
          this.tr2.push(td);
          this.pages2.push(this.tr2);
          this.tr2 = []
        }
      }
      else if(count === skusLength-1) {
        td.push({code : sku.upcCode, scanCode : sku.qrCode, name : sku.productName, erpCode:sku.erpCode,workOrderRef:sku.workOrderRef})

        if(td.length === 1){
          let obj = {code:"",scanCode:"assets/img/images.png",name:"", erpCode:"",workOrderRef:""}

          td.push(obj)
        }
        this.tr2.push(td);
        this.pages2.push(this.tr2);
        this.tr2 = []
      }else {
        td.push({code : sku.upcCode, scanCode : sku.qrCode, name : sku.productName, erpCode:sku.erpCode,workOrderRef:sku.workOrderRef})
      }

      if(count % 10 === 0 && count !== 0){
        console.log("ggggggggggggggggggggggggggggggggggggggggggggggggg "+ count)
        this.pages2.push(this.tr2);
        this.tr2 = []
      }
      count++;
    }

    console.log("xxxxxxxxxxxxxxxxxxxxxxxtttttttttttttttttttttxxxtt " + JSON.stringify(this.pages2));
  }


  printSkusScanCodes3(){

    let td = [];
    let count = 0
    let skusLength = this.skusJsonExpended.length;
    for(let sku of this.skusJsonExpended){

      console.log("COOUUNNTTT "+ count + " " + skusLength);
      if(count % 1 === 0 && count !== 0){
        this.tr3.push(td);
        td = [];
        td.push({code : sku.upcCode, scanCode : sku.qrCode, name : sku.productName, erpCode:sku.erpCode,workOrderRef:sku.workOrderRef})
        if(count === skusLength-1){
          // if(td.length === 1){
          //   let obj = {code:"",scanCode:"assets/img/images.png",name:"", erpCode:"",workOrderRef:""}
          //
          //   td.push(obj)
          // }
          this.tr3.push(td);
          this.pages3.push(this.tr3);
          this.tr3 = []
        }
      }
      else if(count === skusLength-1) {
        td.push({code : sku.upcCode, scanCode : sku.qrCode, name : sku.productName, erpCode:sku.erpCode,workOrderRef:sku.workOrderRef})

        // if(td.length === 1){
        //   let obj = {code:"",scanCode:"assets/img/images.png",name:"", erpCode:"",workOrderRef:""}
        //
        //   td.push(obj)
        // }
        this.tr3.push(td);
        this.pages3.push(this.tr3);
        this.tr3 = []
      }else {
        td.push({code : sku.upcCode, scanCode : sku.qrCode, name : sku.productName, erpCode:sku.erpCode,workOrderRef:sku.workOrderRef})
      }

      if(count % 3 === 0 && count !== 0){
        console.log("ggggggggggggggggggggggggggggggggggggggggggggggggg "+ count)
        this.pages3.push(this.tr3);
        this.tr3 = []
      }
      count++;
    }

    console.log("xxxxxxxxxxxxxxxxxxxxxxxtttttttttttttttttttttxxxtt " + JSON.stringify(this.pages3));
  }

  getQRCode(code){
    // console.log("lllllllllllllllllllllll " + code)
    if(code !== undefined){
      return code;
    }
    return ""
  }

  // barcodeMaker(){
  //
  //   for(let sku of this.skusJson){
  //
  //     sku.qrCode = this.process(sku.upcCode);
  //     console.log("ssssskkkuuuu sku.qrCode " + this.process(sku.upcCode))
  //   }
  //
  //   console.log("ssssskkkuuuu " + this.skusJson[0].qrCode)
  //
  // }

  displayQrCode() {
    return this.generate !== '';
  }

  getLabelTypes() {

    this.skusJsonExpended = []
    this.tr = []
    this.tr2 = []
    this.tr3 = []
    this.pages = []
    this.pages2 = []
    this.pages3 = []

    // if(this.locationPopUpOpenStatus == false){
    //   this.locationPopUpOpenStatus = true;
    //   this.gVLogger.log(" iiiiteemmms in cart   " + this.cart.items.length);

      // let loc = "";

      // loc = "-1";

      // this.api.get("products/getLocationsByAdpCustomerId/?searchString="+ loc)
      //   .map(res => res.json())
      //   .subscribe(data => {
      //     if(data.status === "200"){
            let items = [{name : "30", code : 1},{name : "10", code : 2}];
            // for(let item of data.data){
              // let loc = item.name + " (" + item.locationCode + ")";

              // let loc = {name : "30", code : 1}
              // let loc2 = {name : "10", code : 1}
              // items.push(loc);
              // items.push(loc);
              // this.gVLogger.log("daaaattaaaaa : " + this.items);
            // }

            let model = this.modalController.create(LableTypesPage, {items: items});
            model.onDidDismiss(data => {
              this.gVLogger.log("data on dismiss : " + data);
              if(data !== "" && data != null){

                // alert(data.code)

                this.offset = parseInt(data.offset)


                for(let i = 0; i < this.offset; i++){

                  let obj = {productName:"",upcCode:"",quantityPicked:0, scanCode:"", erpCode:"",workOrderRef:""}
                  this.skusJsonExpended.push(obj);
                  this.gVLogger.log("supplierSelecteddddddddddddddddddd : " + JSON.stringify(this.skusJsonExpended));
                }

                for(let sku of this.skusJson){
                  for(let i =0; i < sku.quantityPicked; i++){
                    let obj = {productName:sku.productName,upcCode:sku.upcCode,quantityPicked:sku.quantityPicked
                      , erpCode:sku.erpCode,workOrderRef:this.workOrder.referenceNo}
                    this.skusJsonExpended.push(obj);
                  }
                }
                this.process()


                setTimeout(()=> {
                  this.gVLogger.log("codeeeeeeeeeeeeeee : " + data.code);

                  if(data.code == 1)
                    this.doScanCodesPrintWeb()
                  else if(data.code == 2)
                    this.doScanCodesPrintWeb2()
                  else
                    this.doScanCodesPrintWeb3()
                },2000)

                // this.productLocation = data;
                // this.productLocation = data.name + " (" + data.locationCode + ")";
                // this.productLocationCode = data.locationCode;
                // this.stockCartManager.setLocation(data.locationCode);

              }
              else {

              }
            });
            model.present();

            // this.items = [];
          // }

        // });

      setTimeout(() => {
        // this.locationPopUpOpenStatus = false;
      },500)


    // }
    // else{
    //
    // }
  }

  reorderFiles(reorderEvent: CustomEvent): void {
    console.log("Reorder filesssss")
    let element = this.uploader.queue.splice(reorderEvent.detail.from, 1)[0];
    this.uploader.queue.splice(reorderEvent.detail.to, 0, element);
  }

  getFiles(){

    return this.uploader.queue.map((fileItem) => {
      return fileItem.file;
    });
  }

  deleteFile(selectedFileName){

    let confirm = this.alertCtrl.create({
      title: 'Are you sure!',
      message: 'You want to delete the selected document.',
      buttons: [
        {
          text: 'Cancel',
          handler: () => {

          }
        },
        {
          text: 'Agree',
          handler: () => {

            // this.shipOrderButton = false;

            // console.log("QQQQQQQQQQQQQQQQQQQQQ ", this.uploader.queue.splice(1,1))
            return this.uploader.queue.map((fileItem) => {
              if(selectedFileName === fileItem.file.name)
                fileItem.remove();

              // alert(fileItem.file.name);
            });



            // this.api.getADPPay("feature/getLicenseStatus?customerUUID="+this.cartManager.getADPCustomerUUID() + "&featureAlias="+ this.constants.Monthly_License_alias+"&consumptionCount=0").map(res => res.json())
            //   .subscribe(data => {
            //     if(data.status === 570 || data.status === 571 || data.status === 403){
            //
            //     }
            //     else if(data.status === 200 || data.status === 270) {
            //
            //
            //     }
            //
            //   });


          }
        },
      ]

    });
    confirm.present();



  }
  deleteFileFromDB(item){

    let confirm = this.alertCtrl.create({
      title: 'Are you sure!',
      message: 'You want to delete the selected document.',
      buttons: [
        {
          text: 'Cancel',
          handler: () => {

          }
        },
        {
          text: 'Agree',
          handler: () => {


            let body = {
              imageName : item.docName + item.docExtension
            }

            this.api.imageUploaderPost("/deleteDocumentsWithWarehouseId", body, item.docModuleId, "workOrders", loginUserInfo.countryAbbrivation, item.sourceUuid)
              .map(res => res.json())
              .subscribe(resp => {
                  if(resp.status="200"){
                    for (let doc of this.documents){
                      console.log("item " +  item.docName)
                      console.log("doc " +  doc.docName)
                      if(doc.docName === item.docName && doc.docExtension === item.docExtension){
                        let index = this.documents.indexOf(doc)
                        if (index > -1) {
                          this.documents.splice(index, 1); // 2nd parameter means remove one item only
                        }
                      }
                    }

                    // this.nav.setRoot(MyOrderPage);

                    this.msgManager.toastMsg("Document Deleted Successfully!");
                    // do nothing
                    // alert("Documents uploaded")

                  }else{ // check for session out
                    this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

                    // this.nav.setRoot(LoginPage);
                  }

                }
                , error =>{
                  this.msgManager.toastMsg(this.msgManager.getOrderPlaceFailMsg());
                  //alert(JSON.stringify(error));
                });


          }
        },
      ]

    });
    confirm.present();



  }
  fileOverBase(event): void {
    console.log("fileOverBase" + event)
    this.hasBaseDropZoneOver = event;

    // var e = window.event || event;
    // var target = e.target || e.srcElement;
    // var files = target.files;
    // var file = files[0];
    //
    // alert("file name " + file.name)
    //
    // this.checkFile(file);
  }



  upload(orderId) {
    let files = this.getFiles();

    let formData = new FormData();
    // formData.append('uuid', localStorage.get("uuid")); // Add any other data you want to send
    // files.forEach((file) => {
    // formData.set('docs', "umar");
    for(let file of files){
      formData.append('docs', file.rawFile, file.name);
    }

    // for (var key of formData.has("docs")) {
    console.log("yyyyyyyyyyyyyyyyyyyyyy" + formData.get("docs"));



    this.api.imageUploaderPost("/uploadDocumentsWithWarehouseId", formData, orderId, "workOrders", loginUserInfo.countryAbbrivation, this.cartManager.getADPCustomerUUID())
      .map(res => res.json())
      .subscribe(resp => {
          if(resp.status="200"){
            // this.nav.setRoot(MyOrderPage);
            // alert("Documents uploaded")
            this.removeAllItemsAfterUpload()
            this.getDocuments();



          }else if(resp.status == "401"){ // check for session out
            this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

            this.nav.setRoot(LoginPage);
          }

        }
        , error =>{
          this.msgManager.toastMsg(this.msgManager.getOrderPlaceFailMsg());
          //alert(JSON.stringify(error));
        });
  }

  getDocUrl(item){
    return RoutingInfo.imageBaseUrl + "/" + item.sourceUuid + "/docs/" + item.docModule + "/" + item.docName + "---" + item.docModuleId + item.docExtension;
    // return RoutingInfo.imageBaseUrl + "/" + item.sourceUuid + "/docs/" + item.docModule + "/" + item.docName + item.docExtension;
  }

  selectedCalled(event){
    var e = window.event || event;
    var target = e.target || e.srcElement;
    var files = target.files;
    var file = files[0];

    console.log("file name " + file.name)


    this.checkFile(file);
  }


  public onFileDrop(event): void {
    var e = window.event || event;
    var target = e.target || e.srcElement;
    var files = target.files;
    var file = files[0];

    console.log("file name " + file.name)

    // alert("file name " + file.name)

    // this.checkFile(file);
  }


  checkFile(file){

    let fileAlreadyExist = 0;

    this.uploader.queue.map((fileItem) => {
      if(file.name === fileItem.file.name){
        console.log("EXist file " + fileAlreadyExist)
        // fileItem.remove();

        fileAlreadyExist++;

        // alert(fileItem.file.name);
      }


    });

    if(fileAlreadyExist === 2){
      this.uploader.queue.map((fileItem) => {
        if(file.name === fileItem.file.name && fileAlreadyExist === 2){
          fileItem.remove();
          this.msgManager.toastMsg("Document with the same name already exist!");
          fileAlreadyExist = 1;
          return;
        }
        // alert(fileItem.file.name);
      });
    }


    var lastIndex = file.name.lastIndexOf('.');

    let extension = file.name.substr(lastIndex);
    let name = file.name.substr(0, lastIndex)

    if(extension !== ".csv" &&
      extension !== ".doc" &&
      extension !== ".docx" &&
      extension !== ".xlsx" &&
      extension !== ".pdf" &&
      extension !== ".png" &&
      extension !== ".jpg" &&
      extension !== ".jpeg" &&
      extension !== ".jfif" &&
      extension !== ".txt" &&
      extension !== ".zip"
    ){
      return this.uploader.queue.map((fileItem) => {
        if(file.name === fileItem.file.name){
          fileItem.remove();

          this.msgManager.toastMsg("Document format not supported!");
        }


        // alert(fileItem.file.name);
      });
    }
  }


  public fileOver(fileIsOver: boolean): void {
    this.fileIsOver = fileIsOver;
  }



  removeAllItemsAfterUpload(){

    this.uploader = new FileUploader({})
    this.msgManager.toastMsg("Files uploaded successfully!");



    // this.uploader.queue.map((fileItem) => {
    //   // if(selectedFileName === fileItem.file.name)
    //     fileItem.remove();
    //
    //   // alert(fileItem.file.name);
    // });
  }


  getDocuments(){
    var body = {
      docModule : "workOrders",
      docModuleId  : this.workOrder.id,
      sourceUuid : this.cartManager.getADPCustomerUUID(),
      parentInventoryLocationId : loginUserInfo.assignedWarehouseId
    }
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({
      headers: headers
    });
    this.api.post("getDocAgainstWorkOrder", body, options)
      .map(res => res.json())
      .subscribe(resp => {
          if (resp.status === "200") {
            // alert(resp.data)
            this.documents = resp.data;
          }

        }
        , error => {

        });
  }

  getDisabledStatus(item){
    if(this.cartManager.getADPCustomerUUID() === item.sourceUuid){
      return true;
    }else {
      return false;
    }
  }

  commentHtmlDisplay(description){
    // this.gVLogger.log( "decjsdkld ghjd gnkxdhn   : " + atob(description));

    if(description !== undefined && description !== null){
      try {
        // this.gVLogger.log("In try decoded description : " + Base64.decode(description));
        // this.gVLogger.log("In try encoded description : " + description);
        this.divID2.nativeElement.innerHTML = description;
      }
      catch (e) {
        this.gVLogger.log("In catch decoded description : ")
        this.divID2.nativeElement.innerHTML = description;
      }
    }else {
      return ""
    }


  }

  getCommentWithOutHtml(comment){
    if(comment !== undefined && comment !== null){
      comment = comment.replaceAll("<br/>","\n")
      comment = comment.replaceAll("&nbsp;"," ")
      comment = comment.replaceAll("<span style=\"font-size:11px\">"," ")
      comment = comment.replaceAll("</span>"," ")
      return comment;
    }
    else {
      return ""
    }


  }

  consumeInventory(){
    let consumeParams = {
      calledFrom : "workOrder",
      warehouseId : this.workOrder.parentInventoryLocationId,
      customerOrderNumber : this.workOrder.referenceNo
    }
    // this.nav.setRoot(ItemsPage, {workOrderParams:consumeParams});
    this.nav.setRoot(ConsumeStockCart, {workOrderParams:consumeParams});
  }


  getConsumedItems(){
    let body = {
      customerOrderNumber: this.workOrder.referenceNo
    }
    this.api.post("order/getByCustomerOrderNumberAndSystemCustomer" ,body).map(res => res.json()).subscribe(OrderData => {
      this.gVLogger.log("data from /products/getProductsForPickShip : " + OrderData);
      if(OrderData.status === "200") {

            let order = OrderData.data;


        for(let orderDetail of order.orderDetailDTOs){
          let productLocal: any = orderDetail.productsDTO;
          productLocal.quantity = orderDetail.quantity
          productLocal.orderId = orderDetail.orderId
          this.consumedItemsList.push(productLocal);
        }

        console.log("iiiiiiiiiiiiidddddddddd " +this.consumedItemsList[0].orderId)


      }

    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/work-order-view/work-order-view.ts